<div class="nav-backdrop" *ngIf="isOpen" (click)="closeNav()"></div>
<div class="mobile-nav-panel">
    <div class="nav-logo d-flex align-items-center justify-content-between">
        <logo [height]="50" [white]= "color === 'dark'"></logo>
        <div class="cursor-pointer" (click)="closeNav()">
            <i class="feather icon-arrow-left font-size-lg"></i>
        </div>
    </div>
    <perfect-scrollbar class="side-nav-content">
        <div style="position: static;" class="ps" ng-reflect-disabled="false">
            <div class="ps-content">
                <div ng-reflect-border="false">
                    <ul class="nav-menu">
                        <li class="nav-menu-item">
                            <a routerLinkActive="router-link-active" routerLink="/dashboard">
                                <i ng-reflect-ng-class=",feather,icon-home" class="feather icon-home ng-star-inserted"></i>
                                <span class="nav-menu-item-title">Dashboard </span></a>
                        </li>
    
                        <!-- User submenu -->
                        <li class="ng-tns-c22-4 nav-submenu">
                            <!-- Your existing HTML content remains unchanged -->
    
                            <div class="nav-submenu-title ng-tns-c22-4" (wheel)="toggleSubMenu('user', $event)"
                                (click)="toggleSubMenu('user', $event)">
                                <i class="feather icon-users ng-star-inserted"></i>
                                <span class="ng-star-inserted">User</span>
                                <i class="nav-submenu-arrow ng-tns-c22-41 el-icon-arrow-down"></i>
                                <span *ngIf="submenus['user']"></span>
                            </div>
    
                            <!-- Other existing HTML content remains unchanged -->
    
                            <ul class="nav-menu ng-tns-c22-4 ng-trigger ng-trigger-dropAnimation"
                                [@slideInOut]="submenus['user'] ? 'visible' : 'hidden'">
                                <!-- User submenu items go here -->
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/Adduser">
                                        <span class="nav-menu-item-title">
                                            <i class="feather icon-user-plus ng-star-inserted"></i>Add User
                                        </span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/UserProfile">
                                        <span class="nav-menu-item-title">
                                            <i class="la-user-circle la ng-star-inserted"></i>
                                            User Profile </span>
                                    </a>
                                </li>
                            </ul>
                        </li>
    
    
    
                        <li class="ng-tns-c22-4 nav-submenu">
                            <!-- Your existing HTML content remains unchanged -->
                            <div class="nav-submenu-title ng-tns-c22-4" (wheel)="toggleSubMenu('admin', $event)"
                                (click)="toggleSubMenu('admin', $event)">
                                <i class="feather icon-box ng-star-inserted"></i>
                                <span class="ng-star-inserted">Technical</span>
                                <i class="nav-submenu-arrow ng-tns-c22-41 el-icon-arrow-down"></i>
                                <span *ngIf="submenus['admin']"></span>
                            </div>
    
                            <!-- Other existing HTML content remains unchanged -->
    
    
                            <ul class="nav-menu ng-tns-c22-4 ng-trigger ng-trigger-dropAnimation"
                                [@slideInOut]="submenus['admin'] ? 'visible' : 'hidden'">
                                <!-- Admin submenu items go here -->
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/Reports">
                                        <span class="nav-menu-item-title"> <i
                                                class="feather icon-file-text ng-star-inserted"></i>Report Manager</span>
                                    </a>
                                </li>
                                <span class="nav-item">ORDER MANAGER</span>
                                <!-- <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/clientList">
                                        <span class="nav-menu-item-title"> <i
                                                class="la-book-reader la ng-star-inserted"></i>Customer Master</span>
                                    </a>
                                </li> -->
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/confrmList">
                                        <span class="nav-menu-item-title"> <i
                                                class="la-book-reader la ng-star-inserted"></i>Order List</span>
                                    </a>
                                </li>
                                <!-- <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/MaterialList">
                                        <span class="nav-menu-item-title"><i
                                                class="feather icon-shopping-cart ng-star-inserted"></i>Material List
                                        </span>
                                    </a>
                                </li> -->
                                <!--  -->
                                <!-- <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/confrmTecList">
                                        <span class="nav-menu-item-title">
                                            <i class="feather icon-pocket ng-star-inserted"></i>Confirm Orders</span>
                                    </a>
                                </li> -->
                                <span class="nav-item">JOB SPECS</span>
                                <!-- <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active"
                                        routerLink="/jssCreation">
                                        <span class="nav-menu-item-title"> <i
                                                class="feather icon-file ng-star-inserted"></i>
                                            Create JSS File</span>
                                    </a>
                                </li> -->
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active"
                                        routerLink="/jssCreation">
                                        <span class="nav-menu-item-title"> <i
                                                class="feather icon-file ng-star-inserted"></i>
                                            Pending JSS</span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/jsslist">
                                        <span class="nav-menu-item-title"> <i
                                                class="feather icon-file ng-star-inserted"></i>
                                            Done JSS</span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/materialMix">
                                        <span class="nav-menu-item-title"> <i
                                                class="feather icon-archive ng-star-inserted"></i>Material Mixer</span>
                                    </a>
                                </li>
    
                                <!-- <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" ng-reflect-router-link-active="router-link-active" ng-reflect-router-link="/attachRecipe" href="/attachRecipe">
                                        <span class="nav-menu-item-title">Attach Recipe</span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" ng-reflect-router-link-active="router-link-active" ng-reflect-router-link="/mixerRecipe" href="/mixerRecipe">
                                        <span class="nav-menu-item-title">Mixer Recipe</span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" ng-reflect-router-link-active="router-link-active" ng-reflect-router-link="/matAllocation" href="/matAllocation">
                                        <span class="nav-menu-item-title">Mat Allocation</span>
                                    </a>
                                </li> -->
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/UnsavedOrder">
                                        <span class="nav-menu-item-title">
                                            <i class="feather icon-file-plus"></i>Final (Save Ticket)</span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/printTicket">
                                        <span class="nav-menu-item-title"><i class="feather icon-printer"></i>Print Ticket</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
    
                        <li class="ng-tns-c22-4 nav-submenu">
                            <div class="nav-submenu-title ng-tns-c22-4" (wheel)="toggleSubMenu('sale', $event)"
                                (click)="toggleSubMenu('sale', $event)">
                                <i class="feather icon-bar-chart ng-star-inserted"></i>
                                <span class="ng-star-inserted">Sales</span>
                                <i class="nav-submenu-arrow ng-tns-c22-41 el-icon-arrow-down"></i>
                                <span *ngIf="submenus['sale']"></span>
                            </div>
    
                            <ul class="nav-menu ng-tns-c22-4 ng-trigger ng-trigger-dropAnimation"
                                [@slideInOut]="submenus['sale'] ? 'visible' : 'hidden'">
                                <!-- User submenu items go here -->
                                <span class="nav-item mb-3">CUSTOMER INFO</span>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/Reports">
                                        <span class="nav-menu-item-title"> <i
                                                class="feather icon-file-text ng-star-inserted"></i>Report Manager</span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/addclient">
                                        <span class="nav-menu-item-title"><i class="feather icon-users"></i> Add New Client </span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/clientList">
                                        <span class="nav-menu-item-title"><i class="feather icon-list"></i>Client List</span>
                                    </a>
                                </li>
    
    
                                <span class="nav-item">SALES ORDER MANAGER</span>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/place-order">
                                        <span class="nav-menu-item-title"><i class="feather icon-shopping-bag"></i>Create Order</span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/orderList">
                                        <span class="nav-menu-item-title"><i class="feather icon-align-right"></i>Pending Order List</span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/confrmList" >
                                        <span class="nav-menu-item-title"><i class="feather icon-align-left"></i>Confirm Order List</span>
                                    </a>
                                </li>
                                <!-- <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" ng-reflect-router-link-active="router-link-active" ng-reflect-router-link="/confirmOrder" href="/confirmOrder">
                                        <span class="nav-menu-item-title">Unsaved Confirm Orders</span>
                                    </a>
                                </li> -->
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/repeatedorderlist">
                                        <span class="nav-menu-item-title"><i class="feather icon-align-justify"></i>Repeated Order List</span>
                                    </a>
                                </li>
                                <!-- <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" ng-reflect-router-link-active="router-link-active" ng-reflect-router-link="/printingform" href="/printingform">
                                        <span class="nav-menu-item-title">Printing</span>
                                    </a>
                                </li> -->
    
    
                                <!-- <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active"
                                        ng-reflect-router-link-active="router-link-active" ng-reflect-router-link="/Reports"
                                        href="/Reports">
                                        <span class="nav-menu-item-title"> <i
                                                class="feather icon-file-text ng-star-inserted"></i>Report Manager</span>
                                    </a>
                                </li> -->
    
                            </ul>
                        </li>
                        <!--store-->
                        <!-- User submenu -->
                        <li class="ng-tns-c22-4 nav-submenu">
                            <div class="nav-submenu-title ng-tns-c22-4" (wheel)="toggleSubMenu('store', $event)"
                                (click)="toggleSubMenu('store', $event)">
                                <i class="feather icon-database ng-star-inserted"></i>
                                <span class="ng-star-inserted">Store</span>
                                <i class="nav-submenu-arrow ng-tns-c22-41 el-icon-arrow-down"></i>
                                <span *ngIf="submenus['store']"></span>
                            </div>
    
                            <ul class="nav-menu ng-tns-c22-4 ng-trigger ng-trigger-dropAnimation"
                                [@slideInOut]="submenus['store'] ? 'visible' : 'hidden'">
                                <!-- User submenu items go here -->
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/Reports">
                                        <span class="nav-menu-item-title"> <i
                                                class="feather icon-file-text ng-star-inserted"></i>Report Manager</span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/inventory">
                                        <span class="nav-menu-item-title"> <i
                                                class="feather icon-user-plus ng-star-inserted"></i>Inventory List</span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/supply-materials">
                                        <span class="nav-menu-item-title"><i class="la-user-circle la ng-star-inserted"></i>
                                            Supply Materials </span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/stock-bin-details">
                                        <span class="nav-menu-item-title"><i class="la-user-circle la ng-star-inserted"></i>
                                            Returned/Cancelled </span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/factory-issue">
                                        <span class="nav-menu-item-title"><i class="la-user-circle la ng-star-inserted"></i>
                                            Factory Issue </span>
                                    </a>
                                </li>
                            </ul>
                        </li>
    
                        <li class="ng-tns-c22-4 nav-submenu">
                            <div class="nav-submenu-title ng-tns-c22-4" (wheel)="toggleSubMenu('production', $event)"
                                (click)="toggleSubMenu('production', $event)">
                                <i class="feather icon-archive  ng-star-inserted"></i>
                                <span class="ng-star-inserted">Production</span>
                                <i class="nav-submenu-arrow ng-tns-c22-41 el-icon-arrow-down"></i>
                                <span *ngIf="submenus['production']"></span>
                            </div>
    
                            <ul class="nav-menu ng-tns-c22-4 ng-trigger ng-trigger-dropAnimation"
                                [@slideInOut]="submenus['production'] ? 'visible' : 'hidden'">
                                <!-- User submenu items go here -->
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/Reports">
                                        <span class="nav-menu-item-title"> <i
                                                class="feather icon-file-text ng-star-inserted"></i>Report Manager</span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/productionForm">
                                        <span class="nav-menu-item-title"> 
                                            <i class="feather icon-file ng-star-inserted"></i>Add Production Info</span>
                                    </a>
                                </li>
    
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/addInk">
                                        <span class="nav-menu-item-title"> 
                                            <i class="feather icon-file ng-star-inserted"></i>Add Ink Data</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
    
                        <li class="ng-tns-c22-4 nav-submenu">
                            <div class="nav-submenu-title ng-tns-c22-4" (wheel)="toggleSubMenu('dispatch', $event)"
                                (click)="toggleSubMenu('dispatch', $event)">
                                <i class="feather icon-truck"></i>
                                <span class="ng-star-inserted">Dispatch</span>
                                <i class="nav-submenu-arrow ng-tns-c22-41 el-icon-arrow-down"></i>
                                <span *ngIf="submenus['dispatch']"></span>
                            </div>
    
                            <ul class="nav-menu ng-tns-c22-4 ng-trigger ng-trigger-dropAnimation"
                                [@slideInOut]="submenus['dispatch'] ? 'visible' : 'hidden'">
                                <!-- User submenu items go here -->
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/Reports">
                                        <span class="nav-menu-item-title"> <i
                                                class="feather icon-file-text ng-star-inserted"></i>Report Manager</span>
                                    </a>
                                </li>
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/DispatchRemainTable">
                                        <span class="nav-menu-item-title"> 
                                            <i class="feather icon-plus-circle"></i>Dispatch Remain Table
                                        </span>
                                    </a>
                                </li>
                                
                                <li class="nav-menu-item">
                                    <a routerLinkActive="router-link-active" routerLink="/DispatchTable">
                                        <span class="nav-menu-item-title"> 
                                            <i class="feather icon-grid"></i>Dispatch Information Table
                                        </span>
                                    </a>
                                </li>
                                
                            </ul>
                        </li>
    
    
                    </ul>
                </div><!--container-->
            </div>
        </div>
    </perfect-scrollbar>
    
</div>
<!-- <perfect-scrollbar class="mobile-nav-panel-content">
    <side-nav (onNavLinkClick)="onClicked()"></side-nav>
    <div ng-reflect-border="false">
        <ul class="nav-menu">
            <li class="nav-menu-item">
                <a routerLinkActive="router-link-active" routerLink="/dashboard">
                    <i ng-reflect-ng-class=",feather,icon-home" class="feather icon-home ng-star-inserted"></i>
                    <span class="nav-menu-item-title">Dashboard </span></a>
            </li>

            User submenu
            <li class="ng-tns-c22-4 nav-submenu">
                Your existing HTML content remains unchanged

                <div class="nav-submenu-title ng-tns-c22-4" (wheel)="toggleSubMenu('user', $event)"
                    (click)="toggleSubMenu('user', $event)">
                    <i class="feather icon-users ng-star-inserted"></i>
                    <span class="ng-star-inserted">User</span>
                    <i class="nav-submenu-arrow ng-tns-c22-41 el-icon-arrow-down"></i>
                    <span *ngIf="submenus['user']"></span>
                </div>

                Other existing HTML content remains unchanged

                <ul class="nav-menu ng-tns-c22-4 ng-trigger ng-trigger-dropAnimation"
                    [@slideInOut]="submenus['user'] ? 'visible' : 'hidden'">
                    User submenu items go here
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/Adduser">
                            <span class="nav-menu-item-title">
                                <i class="feather icon-user-plus ng-star-inserted"></i>Add User
                            </span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/UserProfile">
                            <span class="nav-menu-item-title">
                                <i class="la-user-circle la ng-star-inserted"></i>
                                User Profile </span>
                        </a>
                    </li>
                </ul>
            </li>



            <li class="ng-tns-c22-4 nav-submenu">
                Your existing HTML content remains unchanged
                <div class="nav-submenu-title ng-tns-c22-4" (wheel)="toggleSubMenu('admin', $event)"
                    (click)="toggleSubMenu('admin', $event)">
                    <i class="feather icon-box ng-star-inserted"></i>
                    <span class="ng-star-inserted">Technical</span>
                    <i class="nav-submenu-arrow ng-tns-c22-41 el-icon-arrow-down"></i>
                    <span *ngIf="submenus['admin']"></span>
                </div>

                Other existing HTML content remains unchanged


                <ul class="nav-menu ng-tns-c22-4 ng-trigger ng-trigger-dropAnimation"
                    [@slideInOut]="submenus['admin'] ? 'visible' : 'hidden'">
                    Admin submenu items go here
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/Reports">
                            <span class="nav-menu-item-title"> <i
                                    class="feather icon-file-text ng-star-inserted"></i>Report Manager</span>
                        </a>
                    </li>
                    <span class="nav-item">ORDER MANAGER</span>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/clientList">
                            <span class="nav-menu-item-title"> <i
                                    class="la-book-reader la ng-star-inserted"></i>Customer Master</span>
                        </a>
                    </li>
                    
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/orderManager">
                            <span class="nav-menu-item-title"><i
                                    class="feather icon-shopping-cart ng-star-inserted"></i>Current Orders
                            </span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/confrmTecList">
                            <span class="nav-menu-item-title">
                                <i class="feather icon-pocket ng-star-inserted"></i>Confirm Orders</span>
                        </a>
                    </li>
                    <span class="nav-item">JOB SPECS</span>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active"
                            routerLink="/jssCreation">
                            <span class="nav-menu-item-title"> <i
                                    class="feather icon-file ng-star-inserted"></i>
                                Create JSS File</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active"
                            routerLink="/jssCreation">
                            <span class="nav-menu-item-title"> <i
                                    class="feather icon-file ng-star-inserted"></i>
                                Pending JSS</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/jsslist">
                            <span class="nav-menu-item-title"> <i
                                    class="feather icon-file ng-star-inserted"></i>
                                Done JSS</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/materialMix">
                            <span class="nav-menu-item-title"> <i
                                    class="feather icon-archive ng-star-inserted"></i>Material Mixer</span>
                        </a>
                    </li>

                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" ng-reflect-router-link-active="router-link-active" ng-reflect-router-link="/attachRecipe" href="/attachRecipe">
                            <span class="nav-menu-item-title">Attach Recipe</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" ng-reflect-router-link-active="router-link-active" ng-reflect-router-link="/mixerRecipe" href="/mixerRecipe">
                            <span class="nav-menu-item-title">Mixer Recipe</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" ng-reflect-router-link-active="router-link-active" ng-reflect-router-link="/matAllocation" href="/matAllocation">
                            <span class="nav-menu-item-title">Mat Allocation</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/UnsavedOrder">
                            <span class="nav-menu-item-title">
                                <i class="feather icon-file-plus"></i>Final (Save Ticket)</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/printTicket">
                            <span class="nav-menu-item-title"><i class="feather icon-printer"></i>Print Ticket</span>
                        </a>
                    </li>
                </ul>
            </li>

            <li class="ng-tns-c22-4 nav-submenu">
                <div class="nav-submenu-title ng-tns-c22-4" (wheel)="toggleSubMenu('sale', $event)"
                    (click)="toggleSubMenu('sale', $event)">
                    <i class="feather icon-bar-chart ng-star-inserted"></i>
                    <span class="ng-star-inserted">Sales</span>
                    <i class="nav-submenu-arrow ng-tns-c22-41 el-icon-arrow-down"></i>
                    <span *ngIf="submenus['sale']"></span>
                </div>

                <ul class="nav-menu ng-tns-c22-4 ng-trigger ng-trigger-dropAnimation"
                    [@slideInOut]="submenus['sale'] ? 'visible' : 'hidden'">
                    User submenu items go here
                    <span class="nav-item mb-3">CUSTOMER INFO</span>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/addclient">
                            <span class="nav-menu-item-title"><i class="feather icon-users"></i> Add New Client </span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/clientList">
                            <span class="nav-menu-item-title"><i class="feather icon-list"></i>Client List</span>
                        </a>
                    </li>


                    <span class="nav-item">SALES ORDER MANAGER</span>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/place-order">
                            <span class="nav-menu-item-title"><i class="feather icon-shopping-bag"></i>Create Order</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/orderList">
                            <span class="nav-menu-item-title"><i class="feather icon-align-right"></i>Pending Order List</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/confrmList" >
                            <span class="nav-menu-item-title"><i class="feather icon-align-left"></i>Confirm Order List</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" ng-reflect-router-link-active="router-link-active" ng-reflect-router-link="/confirmOrder" href="/confirmOrder">
                            <span class="nav-menu-item-title">Unsaved Confirm Orders</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/repeatedorderlist">
                            <span class="nav-menu-item-title"><i class="feather icon-align-justify"></i>Repeated Order List</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" ng-reflect-router-link-active="router-link-active" ng-reflect-router-link="/printingform" href="/printingform">
                            <span class="nav-menu-item-title">Printing</span>
                        </a>
                    </li>


                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active"
                            ng-reflect-router-link-active="router-link-active" ng-reflect-router-link="/Reports"
                            href="/Reports">
                            <span class="nav-menu-item-title"> <i
                                    class="feather icon-file-text ng-star-inserted"></i>Report Manager</span>
                        </a>
                    </li>

                </ul>
            </li>
            store
            User submenu
            <li class="ng-tns-c22-4 nav-submenu">
                <div class="nav-submenu-title ng-tns-c22-4" (wheel)="toggleSubMenu('store', $event)"
                    (click)="toggleSubMenu('store', $event)">
                    <i class="feather icon-database ng-star-inserted"></i>
                    <span class="ng-star-inserted">Store</span>
                    <i class="nav-submenu-arrow ng-tns-c22-41 el-icon-arrow-down"></i>
                    <span *ngIf="submenus['store']"></span>
                </div>

                <ul class="nav-menu ng-tns-c22-4 ng-trigger ng-trigger-dropAnimation"
                    [@slideInOut]="submenus['store'] ? 'visible' : 'hidden'">
                    User submenu items go here
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/inventory">
                            <span class="nav-menu-item-title"> <i
                                    class="feather icon-user-plus ng-star-inserted"></i>Inventory List</span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/supply-materials">
                            <span class="nav-menu-item-title"><i class="la-user-circle la ng-star-inserted"></i>
                                Supply Materials </span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/stock-bin-details">
                            <span class="nav-menu-item-title"><i class="la-user-circle la ng-star-inserted"></i>
                                Returned/Cancelled </span>
                        </a>
                    </li>
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/factory-issue">
                            <span class="nav-menu-item-title"><i class="la-user-circle la ng-star-inserted"></i>
                                Factory Issue </span>
                        </a>
                    </li>
                </ul>
            </li>

            <li class="ng-tns-c22-4 nav-submenu">
                <div class="nav-submenu-title ng-tns-c22-4" (wheel)="toggleSubMenu('production', $event)"
                    (click)="toggleSubMenu('production', $event)">
                    <i class="feather icon-archive  ng-star-inserted"></i>
                    <span class="ng-star-inserted">Production</span>
                    <i class="nav-submenu-arrow ng-tns-c22-41 el-icon-arrow-down"></i>
                    <span *ngIf="submenus['production']"></span>
                </div>

                <ul class="nav-menu ng-tns-c22-4 ng-trigger ng-trigger-dropAnimation"
                    [@slideInOut]="submenus['production'] ? 'visible' : 'hidden'">
                    User submenu items go here
                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/productionForm">
                            <span class="nav-menu-item-title"> 
                                <i class="feather icon-file ng-star-inserted"></i>Add Production Info</span>
                        </a>
                    </li>

                    <li class="nav-menu-item">
                        <a routerLinkActive="router-link-active" routerLink="/addInk">
                            <span class="nav-menu-item-title"> 
                                <i class="feather icon-file ng-star-inserted"></i>Add Ink Data</span>
                        </a>
                    </li>
                </ul>
            </li>




        </ul>
    </div>
</perfect-scrollbar> -->
